export default __webpack_public_path__ + "static/devotionfaith-c9361822846ead519b7ac8589df245be.jpg";